import './login-form.scss';
import {
	sha256,
	onVisible,
	setInputBorderRed,
} from '../../assets/js/modules/common';
import {
	sendFormSubmitted,
	sendFormViewed,
} from '../../assets/js/tracking/eventsTracking';
import { closeModal } from '../modal/modal';
import { setUserSubscribedCookie } from '../../assets/js/modules/authentication';
import { isValidEmailOnInput } from '../../assets/js/modules/validation';
import { handleUserFormSubmission } from '../user-form/user-form';
(($) => {
	const closeButton = $('#close-login-modal');
	closeButton.on('click', () => {
		closeModal('login-modal');
	});

	const continueReading = $('#login-form-submit');
	continueReading.on('click', () => {
		if (isValidInput()) {
			sendCoreIdentifyEvent();
			setTimeout(sendFormSubmittedEvent, 3000);
			setTimeout(() => handleUserFormSubmission(getEmail()), 3000);
			closeModal('login-modal');
			setUserSubscribedCookie();
		} else {
			showError();
		}
	});

	const modal = document.getElementById('user-capture-login');
	onVisible(modal, () => {
		sendFormViewedEvent();
	});
})(jQuery);

const getEmail = () => {
	return $('#login-form-email-input').val();
};

const sendCoreIdentifyEvent = () => {
	const email = getEmail();

	const traits = {
		email,
	};
	sha256(email).then(function (hashedEmail) {
		tagular('beam', {
			'@type': 'core.Identify.v1',
			traits,
			userId: hashedEmail,
		});
	});
};

const eventPayload = {
	formType: 'email',
	formName: 'login',
	formId: 'login-form',
	captureType: 'Custom Form',
	capturePlacement: 'Modal',
	valueProp: 'Newsletter',
};

const sendFormSubmittedEvent = () => {
	sendFormSubmitted(eventPayload);
};

const sendFormViewedEvent = () => {
	sendFormViewed(eventPayload);
};

const isValidInput = () => {
	return isValidEmailOnInput('login-form-email-input');
};

const showError = () => {
	setInputBorderRed('login-form-email-input');
};
